module.exports = __webpack_public_path__ + "static/media/Audience@2x.4c20da9a.png";